import React from "react";

const Logo: React.FC = () => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9476_10174)">
        <path
          d="M15.8656 -0.0930176H9.38696V16.8985H15.8656V-0.0930176Z"
          fill="#FABC01"
        />
        <path
          d="M13.7333 9.95199L8.7063 14.0404L19.4763 27.2935L24.5034 23.2051L13.7333 9.95199Z"
          fill="#12CCE8"
        />
        <path
          d="M11.51 9.94855L0.73999 23.2017L5.76702 27.2901L16.537 14.037L11.51 9.94855Z"
          fill="#FF6800"
        />
        <path d="M25.2499 8H0V14.4813H25.2499V8Z" fill="#45CC2E" />
      </g>
      <defs>
        <clipPath id="clip0_9476_10174">
          <rect width="25" height="27" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
